import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import cx from 'classnames';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: 500,
  },
  active: {
    color: (props) => props.isActive && theme.palette.primary.main,
  },
}));

const CollapsableSection = ({
  step,
  disabled,
  isActive,
  title,
  onChange,
  children,
}) => {
  const classes = useStyles({ isActive });

  return (
    <Accordion
      variant="outlinedVariant"
      disableGutters
      disabled={disabled}
      expanded={isActive}
      onChange={() => onChange(step)}
    >
      <AccordionSummary
        sx={{ px: 3, py: 1 }}
        expandIcon={<ExpandMoreIcon className={classes.active} />}
      >
        <Typography className={cx(classes.title, classes.active)}>
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ px: 3 }}>{children}</AccordionDetails>
    </Accordion>
  );
};

export default CollapsableSection;
